import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "BookmarkEmpty.svg",
  "use": "BookmarkEmpty.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"BookmarkEmpty.svg\"><path d=\"M20.4987,55.625A2.9985,2.9985,0,0,1,16.01,53.0221V12.0209a4,4,0,0,1,4-4h24a4,4,0,0,1,4,4V53.0221a2.9985,2.9985,0,0,1-4.4883,2.6029L32.01,49.0509ZM44.01,51.3V12.0209h-24V51.3l10.76-6.1448a2.5,2.5,0,0,1,2.4806,0Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol